<template>
  <base-modal hide-header hide-footer allow-overflow @close="close">
    <div class="col-12" @click.stop="">
      <h2 class="editor-header">{{ $t('sports.add_work') }}</h2>
      <h4>{{ track.routeName }}</h4>
      <div>
          <div class="col-sm-12">
            <span class="span-title">{{ $t('areas.work_time') }}</span>
            <date-time-picker
              v-model:date="workTime"
              class="ml-1 mr-1"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('areas.set_work_time')"
            />
          </div>
          <div class="col-sm-12">
            <span class="span-title">{{ $t('areas.contract') }}</span>
            <open-contract-filter
              :to="workTime"
              :from="workTime"
              :show-company="false"
              :show-title="false"
              @loading="loading=true"
              @loading-completed="loading=false"
              @contract-selected="setContract"
            />
          </div>
          <div class="col-sm-12">
              <span class="span-title">{{ $t('areas.task_type') }}</span>
              <contract-order-multiselect
                  ref="orderFilter"
                  :contract-ids="contract ?  [contract.id] : []"
                  :single-mode="true"
                  @orders-selected="setOrder"
              />
          </div>
          <div class="col-sm-12 d-flex justify-content-end pt-3 pb-3">
            <button
              class="btn btn-secondary form-button"
              @click.stop="close"
            >
              {{ $t('common.cancel') }}
            </button>
            <button
              :disabled="loading"
              class="btn btn-success form-button"
              @click.stop="submitWork"
            >
              {{ $t('common.save') }}
            </button>
          </div>
      </div>
        <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "../mixins/TimeUtils";
import {orderMixin} from "@/components/mixins/OrderMixin";
import OpenContractFilter from "../contract/OpenContractFilter";
import DateTimePicker from "@/components/common/DateTimePicker";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";
import ContractOrderMultiselect from "../order/ContractOrderMultiselect.vue";

export default {
    name: 'SkiTrackWorkEditor',
    components: {ContractOrderMultiselect, BaseModal, OpenContractFilter, DateTimePicker},
    mixins: [restApi, orderMixin, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
        track: {
            type: Object,
            default: null
        },
        city: {
            type: Number,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
            workTime: null,
            customer: null,
            contractor: null,
            contract: null,
            contracts: [],
            order: null
        }
    },
    methods: {
        setOrder(order) {
            this.order = order
        },

        setContractor: function (contractor) {
            this.contractor = contractor
        },

        setContract: function (contract) {
            this.contract = contract
        },

        submitWork: function () {
            this.loading = true
            let params = {
                track_link: this.track.id,
                city: {id: this.city},
                contract: {id: this.contract.id},
                task_type: {id: this.order.contract_task_type.task_type.id},
                time: this.workTime
            }
            this.restAdd(this.skiingTrackWorkUrl, params, this.success, this.fail)
        },

        success: function () {
           this.loading = false
           this.$emit('closeAndUpdate')
        },

        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },

        close: function () {
            this.$emit('close')
        }
    }
}
</script>
<style scoped>
</style>

